import React, { useCallback } from 'react';
import Clickable from '@prisjakt/ui-clickable';
import { SecondaryNavigationLinkGroup } from '../../../../types';

import * as S from './styles';

type NavigationTabProps = {
  id: string;
  title: string;
  selected?: boolean;
  onClick?: (id: string) => void;
};

const NavigationTab = ({
  id,
  title,
  selected,
  onClick,
}: NavigationTabProps) => {
  const onClickHandler = useCallback(
    () => typeof onClick === 'function' && onClick(id),
    [id, onClick]
  );
  return (
    <S.NavigationTab selected={Boolean(selected)}>
      <Clickable onClick={onClickHandler}>{title}</Clickable>
    </S.NavigationTab>
  );
};

type NavigationTabsProps = {
  groups: SecondaryNavigationLinkGroup[];
  currentGroup: string;
  onClick?: (id: string) => void;
};

const NavigationTabs = ({
  groups,
  currentGroup,
  onClick,
}: NavigationTabsProps) => (
  <S.NavigationTabs>
    {groups.length > 1
      ? groups.map(({ property, title, links }) =>
          property && title && links && links.length ? (
            <NavigationTab
              key={property}
              id={property}
              title={title}
              selected={property === currentGroup}
              onClick={onClick}
            />
          ) : null
        )
      : null}
  </S.NavigationTabs>
);

export default NavigationTabs;
